const DRAFT_PREFIX = 'applyt:app-session-draft:v1:';

type Draft = { text: string; savedAt: number };

function storage(): Storage | null {
  try { return typeof window === 'undefined' ? null : window.sessionStorage; } catch { return null; }
}

export function readAppComposerDraft(appId: string): string {
  try {
    const raw = storage()?.getItem(`${DRAFT_PREFIX}${appId}`);
    const parsed = raw ? JSON.parse(raw) as Draft : null;
    return typeof parsed?.text === 'string' ? parsed.text : '';
  } catch { return ''; }
}

export function writeAppComposerDraft(appId: string, text: string): void {
  try {
    const target = storage();
    if (!target) return;
    if (!text.trim()) { target.removeItem(`${DRAFT_PREFIX}${appId}`); return; }
    target.setItem(`${DRAFT_PREFIX}${appId}`, JSON.stringify({ text, savedAt: Date.now() } satisfies Draft));
  } catch { /* session storage can be unavailable in embedded previews */ }
}

export function clearAppComposerDraft(appId: string): void {
  try { storage()?.removeItem(`${DRAFT_PREFIX}${appId}`); } catch { /* noop */ }
}
